import {store} from '../../app/store'
import { notesApiSlice } from '../notes/notesApiSlice'
import { usersApiSlice } from '../users/usersApiSlice'
import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
// Outlet renders the matching child route of a parent route or nothing if no child route matches. import { Outlet } from "react-router" export default function ...

import React from 'react'

const Prefetch = () => {
    useEffect(()=>{
        store.dispatch(notesApiSlice.util.prefetch('getNotes','notesList',{force: true}))
        store.dispatch(usersApiSlice.util.prefetch('getUsers', 'usersList',{force: true}))
        // console.log('subscribing');
        // const notes = store.dispatch(notesApiSlice.endpoints.getNotes.initiate())
        // const users = store.dispatch(usersApiSlice.endpoints.getUsers.initiate())

        // return ()=>{
        //     console.log('Unsubscribing');
        //     notes.unsubscribe()
        //     users.unsubscribe()
        // }
    },[])
    return <Outlet/>
}

export default Prefetch
